__turbopack_context__.v({
  "button-icon": "email-signup-module-scss-module__cRw3Zq__button-icon",
  "confirm": "email-signup-module-scss-module__cRw3Zq__confirm",
  "form-fields": "email-signup-module-scss-module__cRw3Zq__form-fields",
  "homepage-email": "email-signup-module-scss-module__cRw3Zq__homepage-email",
  "input-wrapper": "email-signup-module-scss-module__cRw3Zq__input-wrapper",
  "label": "email-signup-module-scss-module__cRw3Zq__label",
  "status": "email-signup-module-scss-module__cRw3Zq__status",
  "submit": "email-signup-module-scss-module__cRw3Zq__submit",
  "title": "email-signup-module-scss-module__cRw3Zq__title",
  "validation-error": "email-signup-module-scss-module__cRw3Zq__validation-error",
  "wrapper": "email-signup-module-scss-module__cRw3Zq__wrapper",
});
